import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip,
  CartesianGrid, LabelList
} from "recharts";

export default function SlaBuckets({
  stats = { answered_calls:0, under_t1:0, under_t2:0, under_t3:0 },
  t1 = 10, t2 = 20, t3 = 30
}) {
  const isDark = typeof window !== "undefined" &&
                 window.matchMedia &&
                 window.matchMedia("(prefers-color-scheme: dark)").matches;

  const COLORS = {
    grid: isDark ? "#2b2b2b" : "#e5e7eb",
    tick: isDark ? "#e5e7eb" : "#1f2937",
    bar:  isDark ? "#8b93ff" : "#4f46e5",
    tooltipBg: isDark ? "#1a1a1a" : "#ffffff",
    tooltipBorder: isDark ? "#333" : "#ddd",
  };

  const total = Number(stats.answered_calls || 0) || 1;
  const data = [
    { name:`≤ ${t1}s`, value: (Number(stats.under_t1||0) * 100) / total },
    { name:`≤ ${t2}s`, value: (Number(stats.under_t2||0) * 100) / total },
    { name:`≤ ${t3}s`, value: (Number(stats.under_t3||0) * 100) / total },
  ];

  return (
    <div style={{height:260}}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid stroke={COLORS.grid} />
          <XAxis dataKey="name" tick={{ fill: COLORS.tick }} />
          <YAxis domain={[0, 100]} tick={{ fill: COLORS.tick }} />
          <Tooltip
            formatter={(v)=>`${Number(v).toFixed(1)}%`}
            contentStyle={{ background: COLORS.tooltipBg, border: `1px solid ${COLORS.tooltipBorder}`, color: COLORS.tick }}
            labelStyle={{ color: COLORS.tick }}
          />
          <Bar dataKey="value" fill={COLORS.bar} fillOpacity={0.95}>
            <LabelList position="top" formatter={(v)=>`${Number(v).toFixed(0)}%`} fill={COLORS.tick}/>
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
